import React from 'react';
import {_GPY} from '../../../env.js'

class LineUp extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      active: false,
      data  : undefined,
      overlayConfig: this.props.display.state.overlays!==undefined&&this.props.display.state.overlays[this.props.overlayConf]!==undefined?this.props.display.state.overlays[this.props.overlayConf].overlay:{},
      transition : "transition-start" ,
    };
  }

  onSetTimeout(){
    console.log(this.props.stateName+" onSetTimeout");
  }

  onInit(overlayConfig){
      this.setState({transition: this.state.overlayConfig.transition +"-active"});
  }

  preparePlayer(p) {
    console.log("preparePlayer()");
		if(p.vsUiState === undefined || p.vsUiState === '') {
				p.vsUiState = '{"player":false, "substitue":false,  "pos": {"x": 10, "y": 10, "xp":5, "yp": 10}}';
		}
		p._config = JSON.parse(p.vsUiState);

    if(p._config.pos!==undefined) {
		    p._config.shadow = false;
		    p._config.pos.x = this.props.display.toXPos(parseFloat(p._config.pos.xp));
		    p._config.pos.y = this.props.display.toYPos(parseFloat(p._config.pos.yp));
    }
	}

  onData (data,key) {

    console.log("###############",key,data);
    if(typeof data === 'object') {

        var doAnim = false;
        if(data.visible === undefined) {
            this.setState({ data:data });
        } else {
          if(data.visible === true ) {
              if(this.state.active !== data.visible) {
                  doAnim=true;
               }
               this.setState({active: data.visible, data:data} , ()=>{
                      if(doAnim)  {
                        this.setState({restartAnim:true},()=>{
                          this.setState({restartAnim:false, active: data.visible, data:data, transition: this.state.overlayConfig.transition +"-active"});
                        });
                      }
               });
          } else {
              this.setState({active: data.visible } , ()=>{
                  this.setState({active: data.visible, transition: this.state.overlayConfig.transition +"-leave"});
              });
          }
      }

    } else if( typeof data === 'number' ) {
        this.setState({numberData: data});
    } else if(typeof data === 'boolean') {
        this.setState({booleanData: data});
    }
  }

  componentDidMount() {
    this.props.display.registDataListener(this.props.stateName,this);
  }

  render() {
    if(this.state.data === undefined || this.state.overlayConfig === undefined || this.state.overlayConfig.elements === undefined || this.state.data.game === undefined) {
      return (<div className={this.state.transition}/>);
    }

    const game = this.state.data.game;
    const field = this.state.overlayConfig.elements.football_field.element;
    if(game.players.Player.length > 0 ) {
        game.players.Player.forEach((p) => {
          this.preparePlayer(p);
        });
    }

    return (
        <div className={this.state.transition} style={{position : "absolute",top:'0px',left:'0px',width:'100%', height:'100%'}}>

        <div style={{
          position : "absolute",
          left : field.x+"px",
          top :  field.y+"px",
          width : field.width+"px",
          height : field.height+"px",
          backgroundSize: "cover",
          backgroundImage: 'url("'+_GPY.resource("upload/"+field.imageSrc)+'")',
        }}>
        {game.players.Player.filter( (p) => p._config.player ).map( (p) =>
            <div key={p.id}  className="rounded" style={{position : "absolute",
            top: p._config.pos.y+"px",
            left: p._config.pos.x + "px",
            backgroundImage: p.profileImage!==undefined&&p.profileImage!==""?'url("'+_GPY.resource("upload/" + p.profileImage )+'")':'url("'+_GPY.resource("images/default_avatar.jpg")+'")',
            backgroundPosition:"center bottom",
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            width : this.props.display.toScaleValue(200)+'px',
            height: this.props.display.toScaleValue(200)+'px'}}>
              <div className="text-center" style={{position : "absolute", top : this.props.display.toScaleValue(210)+'px',width:this.props.display.toScaleValue(400)+"px",left:"-"+this.props.display.toScaleValue(100)+"px",height: this.props.display.toScaleValue(60)+"px"}}>
                <p className="text-light" style={{textShadow: "1px 1px #000000",fontSize:this.props.display.toScaleValue(50)+"px"}}>{p.numOrPos!==undefined&&p.numOrPos!==''?p.numOrPos +" ":""}{p.lastName}</p>
              </div>
            </div>
        )}


        {game.players.Player.filter( (p) => p._config.substitue ).map( (p) =>
            <div key={p.id} className="rounded" style={{position : "absolute",
            top: p._config.pos.y+"px",
            left: p._config.pos.x + "px",
            backgroundImage: p.profileImage!==undefined&&p.profileImage!==""?'url("'+_GPY.resource("upload/" + p.profileImage )+'")':'url("'+_GPY.resource("images/default_avatar.jpg")+'")',
            backgroundPosition:"center bottom",
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            width : this.props.display.toScaleValue(80)+'px',
            height: this.props.display.toScaleValue(80)+'px'}}>
              <div style={{position : "absolute", top : this.props.display.toScaleValue(0)+'px',width:this.props.display.toScaleValue(400)+"px",left: this.props.display.toScaleValue(100)+"px",height: this.props.display.toScaleValue(40)+"px"}}>
                <p className="text-light" style={{textShadow: "1px 1px #000000",fontSize:this.props.display.toScaleValue(35)+"px"}}>{p.numOrPos!==undefined&&p.numOrPos!==''?p.numOrPos +" ":""}{p.lastName}</p>
              </div>
            </div>
        )}


        </div>

        </div>
    );
  }
}
export default LineUp;
